import type { FeatureFlagRepository } from '#/domain/featureFlag/FeatureFlagRepository'

// This app's own GitLab/Unleash flags product — mirrors GITLAB_PRODUCT_NAME_0 / appsettings.json's
// FeatureFlagsConfig.SelfProductName on the backend. There is only one consumer of this today (this
// SPA gating its own catalog-assignment UI), so it is not worth threading through as a parameter.
const SELF_PRODUCT_NAME = 'MyTechnosylva'

export class IsFeatureEnabledUseCase {
  constructor(private readonly repository: FeatureFlagRepository) {}

  async execute(flagName: string, environment?: string): Promise<boolean> {
    const flags = await this.repository.findEnabledFlags(SELF_PRODUCT_NAME, environment)
    return flags.some((f) => f.Flag.toUpperCase() === flagName.toUpperCase() && f.IsEnabled)
  }
}
